/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type CreateOrgAccessRequestMutationVariables = Types.Exact<{
  orgId: Types.Scalars['ID'];
  durationMinutes: Types.Scalars['Int'];
}>;


export type CreateOrgAccessRequestMutation = { __typename: 'Mutation', orgAccessRequestCreate: { __typename: 'ServiceAdminOrgAccessRequestDocument', id: string, status: Types.ServiceAdminOrgAccessRequestStatus } };


export const CreateOrgAccessRequestDocument = gql`
    mutation CreateOrgAccessRequest($orgId: ID!, $durationMinutes: Int!) {
  orgAccessRequestCreate(orgId: $orgId, durationMinutes: $durationMinutes) {
    id
    status
  }
}
    `;
export type CreateOrgAccessRequestMutationFn = ApolloReactCommon.MutationFunction<CreateOrgAccessRequestMutation, CreateOrgAccessRequestMutationVariables>;

/**
 * __useCreateOrgAccessRequestMutation__
 *
 * To run a mutation, you first call `useCreateOrgAccessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrgAccessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrgAccessRequestMutation, { data, loading, error }] = useCreateOrgAccessRequestMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      durationMinutes: // value for 'durationMinutes'
 *   },
 * });
 */
export function useCreateOrgAccessRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOrgAccessRequestMutation, CreateOrgAccessRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateOrgAccessRequestMutation, CreateOrgAccessRequestMutationVariables>(CreateOrgAccessRequestDocument, options);
      }
export type CreateOrgAccessRequestMutationHookResult = ReturnType<typeof useCreateOrgAccessRequestMutation>;
export type CreateOrgAccessRequestMutationResult = ApolloReactCommon.MutationResult<CreateOrgAccessRequestMutation>;
export type CreateOrgAccessRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOrgAccessRequestMutation, CreateOrgAccessRequestMutationVariables>;